import React from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';
import { Icon } from '@workboard/action-item';
import { WbEventHandlerMixins, WbMarkdownHtml, allowFileUpload } from '../../utils/common';
import ImgIconComp from '../imgcomp';
import CommonTags from './commonTags';

import PostTakeEditText from './postTakeEditText';
import TakeAttachment from './takeAttachment';
import PostTopicSubTakeawaysNotes from './postTopicSubTakeawaysNotes';
import DeleteTakeawayPopup from './modals/deleteTakeawayPopup';
import GoalServices from '../../services/goal.services';
import MeetingServices from '../../services/meeting.services';
import { v4 as uuidv4 } from 'uuid';
import { generateSASAnduploadToTempLocation, WoboFileUploadService } from '../../../src/services/fileupload.service';
import { getAiTypeActionLabel, getAiTypeAttributes, getStateComponentIcon } from '../../board/utils';

const StateIconComp = ({ take }) => {
  const { type, state } = take?.wobo_data || {};
  const { attributes } = getAiTypeAttributes(type || 0);
  const stateIconCompName = getStateComponentIcon(
    attributes?.state?.values ?? [],
    state
  );

  return <Icon name={stateIconCompName} width="15" height="15" />;
}

const services = new GoalServices();
// List Relation Takeaways & notes
class ListTakeawaysNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'take',
      tag: '',
      act: 'edit',
      editTakeDesc: false,
      enableText: false,
      elementH: 26,
      hoverStickEn: false,
      discussTakeaway: false,
      bottomTop: 0,
      inlineDialogDropdownOpen: false,
      inlineDialogOwnerImg: '',
      inlineDialogOwnerName: '',
      inlineDialogOwnerFirstName: '',
      inlineDialogOwnerId: '',
      inlineDialogSearchValue: '',
      smartWoboDialogShown: '',
      timerOff: false
    };
    this.MeetingServices = new MeetingServices();
    this.mouseover = this.mouseover.bind(this);
    this.mouseout = this.mouseout.bind(this);
    this.showFuncTopicList = this.showFuncTopicList.bind(this);
    this.hideSubmenuOptsDiv = this.hideSubmenuOptsDiv.bind(this);
    this.deleteTakeAway = this.deleteTakeAway.bind(this);
    this.editTakeText = this.editTakeText.bind(this);
    this.disableTakeText = this.disableTakeText.bind(this);
    this.openTextArea = this.openTextArea.bind(this);
    this.closeTextArea = this.closeTextArea.bind(this);
    this.initDatePicker = this.initDatePicker.bind(this);
    this.remindMeTopicTakeClick = this.remindMeTopicTakeClick.bind(this);
    this.saveReminder = this.saveReminder.bind(this);
    this.convertToActionItem = this.convertToActionItem.bind(this);
    this.urlify = this.urlify.bind(this);
    this.selectAllText = this.selectAllText.bind(this);
    this.topicTakeDesc = this.topicTakeDesc.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.initSortable = this.initSortable.bind(this);
    this.handleSortableUpdateTake = this.handleSortableUpdateTake.bind(this);
    this.isAITakeaway = this.isAITakeaway.bind(this);
    this.aiTopicArea = this.aiTopicArea.bind(this);
    this.enableSortable = this.enableSortable.bind(this);
    this.disableSortable = this.disableSortable.bind(this);
    this.showHoverStick = this.showHoverStick.bind(this);
    this.hideHoverStick = this.hideHoverStick.bind(this);
    this.GoalServices = new GoalServices();
    this.deleteTopicAttach = this.deleteTopicAttach.bind(this);
  }

  componentDidMount() {
    this.initSortable();
    if (this.props.currentUser) {
      this.setState({
        inlineDialogOwnerImg: this.props.currentUser.picture,
        inlineDialogOwnerName: this.props.currentUser.fullName,
        inlineDialogOwnerId: this.props.currentUser.userId
      });
    }
    window.addEventListener('keydown', this.checkKeydownEvents);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.checkKeydownEvents);
  }

  componentDidUpdate() {
    this.initSortable();
  }

  checkKeydownEvents = event => {
    if (event.key === 'Escape') {
      this.setState({
        inlineDialogDropdownOpen: false
      });
    }
  };

  mouseover(cId) {
    $(`.takeawayMenuShow_${cId}`).show();
  }

  mouseout(cId) {
    $(`.takeawayMenuShow_${cId}`).hide();
  }

  showFuncTopicList(e, cId, topicId) {
    $(`.takeawayRelMenuList_${cId}`).show();
    const offset = $(e.target).position();
    const { top } = offset;
    if (
      $('.meetingTopicTakeDetails').length
      && $('.meetingTopicTakeDetails').length > 3
      && $('.meetingTopicTakeDetails:last').hasClass(`dragRows_${topicId}`)
      && $(`.takeawayRelMenuList_${cId}`).height() > 120
    ) {
      this.state.bottomTop = top - 150;
    } else {
      this.state.bottomTop = 0;
    }
  }

  hideSubmenuOptsDiv(id) {
    $(`.takeawayRelMenuList_${id}`).hide();
  }

  deleteTakeAway(id, meetingId, type, topicId, meeting, files) {
    delete_meeting_confirm.dialog('open');
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById('delete-meeting-confirm-box')
      );
    }
    ReactDOM.render(
      <DeleteTakeawayPopup
        id={id}
        meetingId={meetingId}
        type={type}
        topicId={topicId}
        deleteTopicTakeNonTake={this.props.deleteTopicTakeNonTake}
        meeting={meeting}
        meetingObj={this.props.meetingObj}
        isFUSEnabled={this.props.isFUSEnabled}
        files={files}
      />,
      document.getElementById('delete-meeting-confirm-box')
    );
  }

  editTakeText(e, id) {
    if ($(`.takeElem_${id}`).parents('.meeting_take_sortable').length) {
      $(`.takeElem_${id}`)
        .parents('.meeting_take_sortable')
        .addClass('bgwhite');
    }
    const elHeights = $(`.takeElem_${id}`).height();
    this.setState({
      elHeight: elHeights
    });
    if ($(e.target).closest('a').length < 1) {
      this.state.editTakeDesc = id;
    }
  }

  disableTakeText(id) {
    if (this.state.editTakeDesc == id) {
      this.setState({
        editTakeDesc: false
      });
    }
  }

  openTextArea(e) {
    this.setState({
      enableText: true,
      elementH: 52
    });
  }

  closeTextArea() {
    const _this = this;
    _this.state.enableText = false;
    _this.setState({
      enableText: false
    });
  }

  initDatePicker(obj, id) {
    this.datetimepicker = $(obj);
    const _this = this;
    const { t } = this.props;
    $(this.datetimepicker)
      .datetimepicker({
        dateFormat: 'yy-mm-dd',
        timeFormat: 'hh:mm tt',
        minDateTime: 0,
        controlType: 'select',
        currentText: t('Cancel'),
        closeText: t('Set'),
        beforeShow(input, inst) {
          $('#ui-datepicker-div').addClass('dataTimePicker');
          setTimeout(() => {
            inst.dpDiv.css({
              marginLeft: '-20px'
            });
          }, 1);
        },
        onClose(date) {
          function isDonePressed() {
            return (
              $('#ui-datepicker-div')
                .html()
                .indexOf(
                  'ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover'
                ) > -1
            );
          }
          if (isDonePressed()) {
            _this.saveReminder($(this), date, id);
          }
        }
      })
      .datetimepicker('show');
  }

  remindMeTopicTakeClick(id) {
    this.initDatePicker(`#remindTopicTakeMe_${id}`, id);
  }

  saveReminder(obj, date, id) {
    const url = remindMeMeetingItemsUrl;
    const type = 'take';
    if (typeof id !== 'undefined') {
      const posting = $.post(
        url,
        { id, type, dateAndTime: date },
        () => { }
      ).done(res => {
        // TODO: empty block here, handle success/failure?
      });
    }
  }

  urlify(text) {
    if (text && typeof text !== 'undefined' && text.length > 0) {
      const urlRegex = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
      const hasAnchorTags = /<a\b[^>]*>(.*?)<\/a>/gi.test(text);
      return !hasAnchorTags ? text.replace(urlRegex, "<a href='$1' target='_blank'>$1</a>") : text;
    }
    return text;
  }

  selectAllText(e, id) {
    const el = document.getElementsByClassName(`topicNote_${id}`)[0];
    const range = document.createRange();
    range.selectNodeContents(el);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  topicTakeDesc(take, enableDiv, cursorP) {
    const { currentUser, t } = this.props;
    let topicTakeDesc = '';
    let assignedTo = '';
    cursorP = enableDiv || currentUser.id == take.added_by ? 'text' : 'default';
    const styleObj = { cursor: cursorP, lineHeight: '19px' };

    if (take.ai_id != '' && take.ai_id != null) {
      const aiOwnerName = typeof take.aiOwnerName !== 'undefined' ? take.aiOwnerName : '';
      styleObj.width = '68%';
      styleObj.display = 'inline-block';
      assignedTo = (
        <span
          className="meeting-ai-link truncateText cursorPointer"
          title={aiOwnerName}
          style={{ verticalAlign: 'top' }}
          data-url={`${wbConfig.baseUrl}/activity/ActionItemDetails?id=${take.ai_id}&meetingId=${take.meeting_id}`}
        >
          {t('Assigned to {{aiOwnerName}}', { aiOwnerName })}
        </span>
      );
    }

    const htmlTexts = this.urlify(take.description);
    if (enableDiv || currentUser.id == take.added_by) {
      topicTakeDesc = (
        <div
          className={`textAlignLeft takeawayDataElement takeElem_${take.id}`}
          data-take={take.id}
          style={{ cursor: cursorP }}
        >
          <div className="note_tag-icon floatLeft" data-tag={take.tag} />
          <div
            className={`meetingNoWrap wb-table-col-edit-title-desc topicNote_${take.id}`}
            style={styleObj}
            onClick={event => this.editTakeText(event, take.id)}
            data-take={take.id}
            dangerouslySetInnerHTML={WbMarkdownHtml(take.description, true)}
          />
          {assignedTo}
        </div>
      );
    } else {
      topicTakeDesc = (
        <div
          className="textAlignLeft takeawayDataElement"
          data-take={take.id}
          style={{ cursor: cursorP }}
        >
          <div className="note_tag-icon floatLeft" data-tag={take.tag} />
          <div
            className={`meetingNoWrap wb-table-col-edit-title-desc wrap selectSpanCont topicNote_${take.id}`}
            onClick={e => this.selectAllText(e, take.id)}
            style={styleObj}
            dangerouslySetInnerHTML={WbMarkdownHtml(htmlTexts, true)}
            data-value={htmlTexts}
          />
          {assignedTo}
        </div>
      );
    }
    return topicTakeDesc;
  }

  deleteTopicAttach(topicId, takeId, fileId, type, fileSignature) {
    const { isFUSEnabled  } = this.props;
    if (isFUSEnabled && fileSignature) {
      WoboFileUploadService.delete(fileSignature)
    }
    $.get(`${wbConfig.baseUrl}/meeting/deleteAttachment`, { id: fileId,meeting_id:this.props.meetingObj.id, json: true }, (resp) => {
      if (resp.status === 'ok') {
        create_topic('meet', {
          action: 'delete_topic_attc',
          type: 'take',
          data: { id: fileId },
          topicId,
          takeid: takeId,
        });
      }
    });
    this.props.deleteNoteAttach(topicId, takeId, fileId);
  }

  handleFileChange(e, takeId) {
    // TODO!: this code needs to be generalized and moved as it's common to many files within /meetings
    e.preventDefault();
    const {
      isFUSEnabled, userId, orgId, appinID, accessToken, currentUser, t
    } = this.props;
    const _this = this;
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    if (file.size > upload_max_size) {
      alert(t('The file you have uploaded exceeds the maximum size of <{{upload_max_size_configured}}MB.', { upload_max_size_configured: upload_max_size}));
      return;
    }
    const extension = file.name.split('.').pop();
    if (!allowFileUpload('meetings', extension)) {
      alert(t('The file type you have uploaded is not supported.'));
      return;
    }

    const afterUpload = function (wfile) {
      const params = {
        s3key: wfile.key,
        prefix: wfile.prefix,
        fileName: replaceSpcicalCharacter(wfile.name),
        fileSize: wfile.size,
        s3DirectUpload: wfile.s3DirectUpload,
        object_id: takeId,
        object_type: 'take'
      };
      $.ajax({
        url: meetingAttachUrl,
        type: 'POST',
        data: params,
        dataType: 'json',
        async: true,
      })
        .done((response) => {
          if (window.wbConfig.isNewMeetingsEnabled) {
            window.hideAppLoader();
          } else {
            removeLoaderWidget();
          }
          if (typeof response.error !== 'undefined') {
            alert(response.error);
            return;
          }
          let ListOfFile = response.data;
          ListOfFile = ListOfFile.filter(item => item.id == response.fileId);
          _this.props.addNoteAttach(_this.props.topicId, takeId, ListOfFile[0]);
          if (Array.isArray(ListOfFile) && ListOfFile.length) {
            create_topic('meet', {
              action: 'add_take_attc',
              data: ListOfFile[0],
              type: 'take',
              topicId: _this.props.topicId,
              takeid: takeId
            });
          }
        })
        .fail((xhr, status, error) => {
          if (window.wbConfig.isNewMeetingsEnabled) {
            window.hideAppLoader();
          } else {
            removeLoaderWidget();
          }
          console.error(error);
          _this.errorFileUploading;
        });
    }

    const updateFile = (signature, delayMs) => {
      const _this = this;
      const clearTimer = setInterval(async () => {
        services
          .getFileStatus({ signature })
          .then((response) => {
            const jsonData = response?.data
            if (jsonData) {
              if (
                jsonData?.resp?.fus_type == 1 &&
                jsonData?.resp?.fus_status == 1 &&
                jsonData?.resp?.path
              ) {
                clearInterval(clearTimer)
                let ListOfFile = jsonData.resp;
                _this.props.updateNoteAttach(_this.props.topicId, takeId, ListOfFile);
              }
            }
          })
          .catch((err) => {})
      }, delayMs)
    }

    const callUpload = function () {
      if (window.wbConfig.isNewMeetingsEnabled) {
        window.showAppLoader();
      } else {
        showLoaderWidget();
      }
      // If FUS enabled then allow the user to upload the file using FUS
      if (isFUSEnabled) {
        let request_id = uuidv4();
        let targetFolderName = uuidv4();

        generateSASAnduploadToTempLocation(file, {
          appinID,
          request_id,
          accessToken,
          userId,
          orgId,
        }).then((newFilename) => {
          if (newFilename) {
            const fileName = createFilename(file.name)
            const fileSize = file.size;
            const prefix = newFilename
            const params = {
              fileName,
              prefix,
              link_type: 1,
              s3DirectUpload: 2,
              fus_type: 1,
              fus_status: 2,
              fileSize,
              object_id: takeId,
              object_type: 'take'
            }
            $.ajax({
              url: `${wbConfig.baseUrl}/meeting/addMeetingAttachment`,
              type: 'POST',
              data: params,
              dataType: 'json',
              async: true,
            })
              .done((response) => {
                // Polling to get the data and update the attachment details
                const fileObj = {
                  source_fileName: newFilename,
                  file_mimetype: file.type,
                  file_size: file.size,
                  request_id: request_id,
                  signature: prefix,
                  appInID: "woboclient", // Client app id and the same name for client container in the azure
                  byok_tenant_id: "", // this is the tenant id for encrypting the file with
                  file_originalname: fileName, // Name of the file
                  webhook_details: {
                    "host": `${wbConfig.baseDomainUrl}/fus/fusCallback?type=1`,
                    "path": "",
                  },
                  orgId: currentUser.org_id, // Organization id
                  userId: currentUser.id, // User id of the requested user
                  target_folder: targetFolderName, // Name of the target folder inside the target container,
                }
                if (window.wbConfig.isNewMeetingsEnabled) {
                  window.hideAppLoader();
                } else {
                  removeLoaderWidget();
                }
                if (typeof response.error !== 'undefined') {
                  alert(response.error);
                  return;
                }
                let ListOfFile = response.data;
                ListOfFile = ListOfFile.filter(item => item.id == response.fileId);
                _this.props.addNoteAttach(_this.props.topicId, takeId, ListOfFile[0]);
                if (Array.isArray(ListOfFile) && ListOfFile.length) {
                  create_topic('meet', {
                    action: 'add_take_attc',
                    data: ListOfFile[0],
                    type: 'take',
                    topicId: _this.props.topicId,
                    takeid: takeId
                  });
                }
                WoboFileUploadService.processFile(fileObj).then(() => {
                  updateFile(prefix, 15000);
                }).catch((err) => {
                  _this.deleteTopicAttach(_this.props.topicId, takeId, ListOfFile[0].id, 'take', ListOfFile[0].fileSignature)
                })
                removeLoaderWidget();
                //checkData(response.data)
              })
              .fail(() => {
                console.error(t('Something went wrong, please try again later.'));
              })
          }
        })
      } else {
        $.ajax({
          url: `${wbConfig.baseUrl}/workboard/GetS3Data`,
          type: 'GET',
          dataType: 'json'
        })
          .done(resp => {
            const prefix = { resp };
            file.prefix = prefix;
            file.key = replaceS3Key(resp.key, file.name);
            if (resp.encrypt_type === 'azure:sse') {
              // upload file to Azure file storage
              uploadFileToAzureStorage(resp.asc, file.key, file)
                .then(result => {
                  file.s3DirectUpload = 2;
                  afterUpload(file);
                })
                .catch(error => {
                  console.error(error);
                });
            } else {
              // upload SIGNED file to AWS S3
              uploadSignedFileToS3Storage({ resp, file })
                .then(result => {
                  file.s3DirectUpload = 1;
                  afterUpload(file);
                })
                .catch(error => {
                  console.error(error);
                });
            }
          })
          .fail(() => {
            removeLoaderWidget();
            _this.errorFileUploading;
          });
      }
    }

    if (window.FileReader && window.Blob) {
      const filereader = new FileReader();
      filereader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          const uint = new Uint8Array(evt.target.result);
          const bytes = [];
          $.each(uint, (i, byte) => {
            bytes.push(byte.toString(16));
          });
          const hex = bytes.join('').toUpperCase();
          if (hex == '4D5A900' || hex == '4D5A5000' || hex == 'FE49BCB') {
            alert(t('The file type you have uploaded is not supported.'));
            return;
          }
          callUpload();
        }
        $(`#file_input_new_${takeId}`)[0].value = '';
      };
      const blob = file.slice(0, 4);
      filereader.readAsArrayBuffer(blob);
    } else {
      callUpload();
    }
  }

  initSortable() {
    const { topicId } = this.props;
    const _this = this;
    _this.itemDraggable = false;
    $(ReactDOM.findDOMNode(this)).sortable({
      revert: false,
      helper: 'clone',
      items: 'div.sortTakeNote',
      update: this.handleSortableUpdateTake,
      connectWith: `section.dragNoteSec_${topicId}`,
      containment: `section.dragNoteSec_${topicId}`,
      handle: '.hoverStickDiv',
      cancel: ':input,button,[contenteditable]',
      tolerance: 'pointer',
      start(event, ui) {
        _this.itemDraggable = true;
      },
      stop(event, ui) {
        _this.itemDraggable = false;
        _this.hideHoverStick();
      }
    });
  }

  sortTakeaways(topicId, sortedIds) {
    const meetingId = this.props.meetingObj.id;

    $.post(
      `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId}/takeaways/sort`,
      { sequence: sortedIds },
      (data, status) => {
        if (status == 'success') {
          console.log('Successful sort');
          console.log(data);
        }
      }
    );
  }

  handleSortableUpdateTake() {
    const newLists = [];
    const newItems = [...this.props.takeaway];
    const $node = $(ReactDOM.findDOMNode(this));
    const ids = $node.sortable('toArray', { attribute: 'data-id' });
    ids.forEach((id, index) => {
      const item = newItems.find((ni) => ni.id === id);
      if (typeof item !== 'undefined') {
        item.pos = index;
        newLists.push(item);
      }
    });
    // Let React reorder the DOM
    $node.sortable('cancel');
    const { topicId } = this.props;
    this.props.sortTakeNotes(topicId, newLists);
    this.sortTakeaways(topicId, ids);
  }

  isAITakeaway(item) {
    return item.wobo_type === 'take'
      && item.tag == 1
      && item.ai_id
      && (typeof item.wobo_data === 'object');
  }

  aiTopicArea(item) {
    const { t } = this.props;
    const { wobo_data } = item;
    const displayName = `${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const wobo_due_date = wobo_data.due_date
      ? moment.utc(wobo_data.due_date * 1000).format('MMM DD')
      : '';
    const wsName = typeof wobo_data.wsName !== 'undefined' ? wobo_data.wsName : '';
    const wsownerName = typeof wobo_data.ownerName !== 'undefined' ? wobo_data.ownerName : '';
    const { attributes } = getAiTypeAttributes(wobo_data?.type ?? 0);
    const ragIconName = getStateComponentIcon(
      attributes?.rag?.values ?? [],
      wobo_data.rag
    );
    const priorityIconName = getStateComponentIcon(
      attributes?.priority?.values ?? [],
      wobo_data.priority
    );
    return (
      <div className="takeawayDataElement">
        <div className={`textAlignLeft takeElem_${item.id}`}>
          <div
            className={`meetingNoWrap wb-table-col-edit-title-desc wrap meetingCursorPointer aiTopicwoboArea dispIB titleText_${item.id}`}
            data-view-acces={wobo_data.view_access}
            onClick={() =>
              WbEventHandlerMixins.aiDetailPage(
                item.wobo_data.id,
                this,
                wobo_data.view_access
              )}
            style={{ textAlign: 'left', width: '68%' }}
            dangerouslySetInnerHTML={WbMarkdownHtml(wobo_data.description, true)}
          />

          <div className="dispIB iconsAITopic floatRight">
            <div className="dispFlex floatRight width100">
              <span className="meet-wobo-ai-duedate-takeaway takeaway-wobo-duedate">
                {wobo_due_date}
              </span>
              <span
                className="wsRag meet-wobo-ai-rag-takeaway"
              >
                <Icon name={ragIconName} width="15" height="15" />
              </span>
              <span
                className="wbStatus meet-wobo-ai-state"
              >
                <Icon name={priorityIconName} width="15" height="15" />
              </span>
            </div>
          </div>
        </div>

        <div className="ai-div-section width100 truncateText">
          {wsName != '' && (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsName}
            >
              {wsName}
            </span>
          )}
          {wsName != '' ? (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsownerName}
            >{`: ${wsownerName}`}
            </span>
          ) : (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsownerName}
            >
              {wsownerName}
            </span>
          )}
          <span
            className="topicUserName truncateText floatRight dispIB"
            style={{ paddingRight: '22px' }}
          >
            {t('Added by:')} &nbsp;{displayName}
          </span>
        </div>
      </div>
    );
  }

  enableSortable() {
    $(ReactDOM.findDOMNode(this)).sortable('option', 'disabled', false);
  }

  disableSortable() {
    $(ReactDOM.findDOMNode(this)).sortable('option', 'disabled', true);
  }

  showHoverStick(e, id) {
    const _this = this;
    if (this.itemDraggable) return;
    _this.setState({
      hoverStickEn: id
    });
  }

  hideHoverStick() {
    if (this.itemDraggable) return;
    this.setState({
      hoverStickEn: !this.state.hoverStickEn
    });
  }

  convertToActionItem(takeId, topicId) {
    const { meetingObj } = this.props
    const params = {
      meetingId: meetingObj.id,
      tag: 1, // tag = 1 represents AIs, vs OKRS and KRS
      type: 'take',
      takeawayId: takeId,
      userId: this.state.inlineDialogOwnerId,
      ...(meetingObj?.ws_id ? { tagId: meetingObj?.ws_id } : {}),
    }

    this.MeetingServices.saveMeetingAI(params)
      .then(resp => {
        this.props.refreshLegacyData(resp.data.data);
      });
  }

  setTagsValue(takeId, topicId, item) {
    // TODO: refactor, this doesn't do what it intended to do in the original code
    item.wobo_data = [];
    item.wobo_data.description = item.description;
    item.wobo_data.due_date = '';
    item.wobo_data.firstname = item.firstname;
    item.wobo_data.wsName = '';
    item.wobo_data.ownerName = item.aiOwnerName;
    item.wobo_data.rag = 0;
    item.wobo_data.priority = 3;
    item.wobo_data.state = 1;
    item.wobo_data.wobo_type_id = 12;

    const tagId = 1;
    this.props.saveTags(
      this.props.meetingObj.id,
      tagId,
      takeId,
      this.state.type,
      this.state.act,
      topicId
    );

    this.setState({
      tag: tagId
    });
  }

  handleInlineOwnerSelect(val) {
    const firstName = val.label.split(' ')[0]

    this.setState({
      inlineDialogOwnerImg: val.picSrc,
      inlineDialogOwnerName: val.label,
      inlineDialogOwnerFirstName: firstName,
      inlineDialogOwnerId: val.value,
      inlineDialogDropdownOpen: false,
      ownerList: []
    });
  }

  filterInlineDropdown(event) {
    // code borrowed from elsewhere in application, still needs some clean-up
    const input = event.target.value;
    let filter = '';
    const _this = this;
    filter = input.toLowerCase();
    filter[0] === ' ' ? filter[0].replace(' ', '') : filter;
    filter[filter.length - 1] === ' '
      ? filter[filter.length - 1].replace(' ', '')
      : filter;

    if (input.length > 2) {
      this.setState(
        {
          inlineDialogSearchValue: filter,
          ownerList: []
        },
        () => {
          if (filter.length > 1) {
            this.GoalServices.getMentionUserList({
              term: filter,
              params: 'title',
              goalId: ''
            }).then(
              response => {
                if (response.data) {
                  _this.setState(
                    {
                      ownerList: response.data
                    }
                  );
                }
              }
            );
          }
        }
      );
    }
  }

  checkSmartWoboInline = () => {
    // if timer hasn't been turned off by user interaction with inline dialog, we want to turn display off
    // on ignore or timer expire, we should trim the value out of redux store to prevent re-display
    if (!this.state.timerOff) {
      // timerOff flag indicates that the user has interacted with the smartwobo dialog in some way, and should remain present until they dismiss or accept (or open another takeaway row that triggers a dialog)
      this.setState({
        smartWoboDialogShown: 'ignored',
        inlineDialogDropdownOpen: false
      });
      this.props.actions.MeetingSetTakeSmartWoboId(null);
    }
  };

  closeSmartWoboInline = () => {
    this.setState({
      inlineDialogDropdownOpen: false
    });
    this.props.actions.MeetingSetTakeSmartWoboId(null)
  }

  displaySmartWoboUsersDropdown = () => {
    const { t } = this.props;
    if (this.state.inlineDialogDropdownOpen) {
      return (
        <div
          id="inlineDialogDropdown"
          className="takeawayInlineDropdownContent"
        >
          <input
            type="text"
            placeholder={t('Search for people')}
            id="takeawayInlineDialogDropdownInput"
            className="aEOwnerSearch"
            onChange={event => this.filterInlineDropdown(event)}
            ref={input => input && input.focus()}
          />
          <div className="takeawayInlineDropdownContentUser">
            {this.state.ownerList
              && this.state.ownerList.map(val => (
                <div
                  className="takeawayInlineDropdownContentRow"
                  key={val.value}
                  onClick={() => {
                    this.handleInlineOwnerSelect(val);
                  }}
                >
                  <div className="takeawayInlineDropdownContentImageContainer">
                    <img
                      className="takeawayInlineDropdownContentImage"
                      src={val.picSrc}
                    />
                  </div>{' '}
                  <span className="takeawayInlineDropdownContentNameResults truncate">
                    {val.label}
                  </span>
                </div>
              ))}
          </div>
        </div>
      );
    }

    return null;
  }

  displaySmartWoboInline = (takeId, topicId) => {
    let renderSmartWobo = false;

    if (this.props.takeSmartWoboId && takeId === this.props.takeSmartWoboId) {
      renderSmartWobo = true;
      // NOTE: The timeout is need it, because the scss is not affecting this component
      setTimeout(this.checkSmartWoboInline, 9000);
    }

    if (this.state.smartWoboDialogShown === 'ignored') {
      renderSmartWobo = false;
    }

    // if criteria are met, render inline dialog
    if (renderSmartWobo) {
      const { t } = this.props;
      const label = getAiTypeActionLabel().toLowerCase();
      return (
        <div className="takeawaySmartWoboContainer">
          <div className="takeawaySmartWoboInline">
            <div className="takeawaySmartWoboInlineDropdownContainer">
              <div className="takeawaySmartWoboInlineDropdownLabel">
                {t('Add this as an {{label}}?', { label })}
              </div>
              <div className="takeawaySmartWoboInlineDropdown">
                <div
                  className="takeawayInlineDropdown truncate"
                  onClick={() => {
                    this.setState({
                      inlineDialogDropdownOpen: !this.state
                        .inlineDialogDropdownOpen,
                      timerOff: true
                    });
                  }}
                >
                  <div className="takeawayInlineDropdownElementContainer">
                    <div className="takeawayInlineDropdownElementContainerImage">
                      <img src={this.state.inlineDialogOwnerImg} />
                    </div>
                    <div className="takeawayInlineDropdownName truncate">
                      {this.state.inlineDialogOwnerName}
                    </div>
                    <div className="takeawayInlineDropdownArrowDown" />
                  </div>
                </div>
              </div>
            </div>
            <div className="takeawaySmartWoboInlineButtons">
              <div className="takeawaySmartWoboInlineButtonAccept">
                <span
                  className="cursor-pointer icon icon-outline-check-18px-green"
                  onClick={() =>
                    this.convertToActionItem(takeId, topicId)}
                />
              </div>
              <div className="takeawaySmartWoboInlineButtonIgnore">
                <span
                  className="cursor-pointer icon icon-outline-close-18px"
                  onClick={this.closeSmartWoboInline}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return <div>&nbsp;</div>;
  };

  render() {
    const takeaways = this.props.takeaway;
    const { meetingObj, t } = this.props;
    const { topicId } = this.props;
    const fName = this.props.topicFname;
    const { updateTopicTake } = this.props;
    const { currentUser } = this.props;
    const { userPermission } = this.props;
    const executeModule = userPermission.execute || false;
    let enableDiv = false;
    if (userPermission.notesAccess || currentUser.id == takeaways.added_by) {
      enableDiv = true;
    }
    const cursorP = enableDiv ? 'pointer' : 'default';
    const topic = this.props.topicList;
    const fromThreeDot = 1;

    let addTakeBtn = 'textShowImg';
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
      if (navigator.userAgent.indexOf('Chrome') != -1) {
        addTakeBtn = 'chromMactextShowImg';
      } else {
        addTakeBtn = 'mozMactextShowImg';
      }
    }
    const label = getAiTypeActionLabel().toLowerCase();
    return (
      <section className={`dragNoteSec_${topicId} takeawayyContainer`}>
        {typeof takeaways !== 'undefined' && takeaways.length > 0
          ? takeaways.map((take, index) => (
            <div
              key={index}
              className={`wb-item-selector takeawayNotes sortTakeNote cursorDefault relTopicTakeList_${topicId}`}
              data-id={take.id}
              data-tag={take.tag}
              data-type="take"
              data-aid={take.ai_id != '' ? take.ai_id : ''}
              style={{
                cursor:
                  enableDiv || currentUser.id == take.added_by
                    ? 'pointer'
                    : 'default'
              }}
            >
              <div className="takeawayParent">
                <div
                  className="takeawayContainer"
                  onMouseOver={() => this.mouseover(take.id)}
                  onMouseOut={e => this.mouseout(take.id)}
                >
                  {this.state.hoverStickEn == take.id ? (
                    <div
                      className="hoverStickDiv hoverStick"
                      onMouseEnter={e => this.showHoverStick(e, take.id)}
                      onMouseLeave={() => this.hideHoverStick()}
                    />
                  ) : (
                    <div
                      className="hoverStickDiv"
                      onMouseEnter={e => this.showHoverStick(e, take.id)}
                      onMouseLeave={() => this.hideHoverStick()}
                    />
                  )}
                  <div className="takeawayProfilePic">
                    {take.tag == 1 && take.wobo_data ? (
                      <div
                        className="meeting-tag-wrapper"
                        style={{ paddingTop: '0px' }}
                      >
                        {take.tag == 1 && (
                          <div
                            className="wb-table-col-edit-title-desc wrap meetingCursorPointer takeArea"
                            data-view-acces="true"
                            onClick={() =>
                              WbEventHandlerMixins.aiDetailPage(
                                take.wobo_data.id,
                                this,
                                true
                              )}
                          >
                            <div
                              className="meeting-tag-options takeawayTagWrapper"
                              data-type={take.wobo_type}
                            >
                              <StateIconComp take={take} />
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <img
                        className="fitProfileImage"
                        src={take.user_picture}
                        width="32"
                        height="32"
                        style={{ borderRadius: '50%' }}
                      />
                    )}
                  </div>
                  <div className="takeawayViewInfo takeawayText">
                    {this.state.editTakeDesc == take.id
                      && (enableDiv || currentUser.id == take.added_by) ? (
                      <PostTakeEditText
                        meetingObj={meetingObj}
                        userPermission={userPermission}
                        take={take}
                        updateTopicTake={updateTopicTake}
                        disableTakeText={this.disableTakeText}
                        topicId={topicId}
                        mentionsUserData={this.props.mentionsUserData}
                        saveTags={this.props.saveTags}
                        elHeight={this.state.elHeight}
                        mtS3Data={this.props.mtS3Data}
                        actions={this.props.actions}
                      />
                    ) : (
                      <div
                        className="takeawayBodyContent"
                        onClick={() => this.props.editTopicArea()}
                      >
                        <div
                          className={`floatRight dispNone takeHideMenuSec takeawayMenuShow_${take.id}`}
                        >
                          <div
                            className="dispIB takeawayKebabContainer"
                            onClick={e =>
                              this.showFuncTopicList(e, take.id, topicId)}
                            onMouseLeave={() =>
                              this.hideSubmenuOptsDiv(take.id)}
                          >
                            <ImgIconComp
                              id="artboard"
                              class="memberPic"
                              width="23"
                              height="23"
                            />

                            <div
                              className={`wspopupmenu-wrapper takeawayMenuText dispNone takeawayRelMenuList_${take.id}`}
                              style={{ top: this.state.bottomTop, right: '24px' }}
                            >
                              {take.ai_id == null
                                && take.tag != 1
                                && (userPermission.notesAccess
                                  || currentUser.id == take.added_by) && (
                                  <CommonTags
                                    ai_id={take.ai_id}
                                    key={`take_${take.id}`}
                                    meeting={meetingObj}
                                    owner={take.added_by}
                                    currentUser={this.props.currentUser}
                                    tag={take.tag}
                                    type={this.state.type}
                                    topicId={topicId}
                                    act={this.state.act}
                                    meetingId={meetingObj.id}
                                    id={take.id}
                                    saveTags={this.props.saveTags}
                                    userPermission={this.props.userPermission}
                                    fromThreeDot={fromThreeDot}
                                  />
                                )}

                              <div
                                className="wspopupmenu-list takeawayMenuText clickable wb-meeting-topic-add"
                                data-type="take"
                                data-meeting-id={meetingObj.id}
                                data-topic-id={topicId}
                                data-take-id={take.id}
                                data-aiid={take.ai_id}
                                data-tagid={take.tag}
                                data-type-id="take"
                                data-desc={take.description}
                              >
                                {t('Add to another meeting')}
                              </div>

                              {take.ai_id == null && executeModule
                                && (enableDiv
                                  || currentUser.id == take.added_by)
                                && take.tag != 1 && (
                                  <div
                                    className="wspopupmenu-list takeawayMenuText clickable"
                                    data-type="take"
                                    data-meeting-id={meetingObj.id}
                                    data-topic-id={take.id}
                                    data-type-id="take"
                                    onClick={() =>
                                      this.convertToActionItem(
                                        take.id,
                                        topicId
                                      )}
                                  >
                                    {t('Convert to {{labelVar}}', { labelVar: label })}
                                  </div>
                                )}
                              {!window.wbConfig.isMeetingsFileUploadHidden && (
                                <div
                                  className={`attachment-list takeawayMenuText clickable attach${index}`}
                                  data-meeting-id={meetingObj.id}
                                  data-type="take"
                                  data-topic-id={take.id}
                                >
                                  <label
                                    className="displayCell clickable"
                                    htmlFor={`file_input_new_${take.id}`}
                                    style={{
                                      display: 'inline-block',
                                      width: '184px',
                                      fontSize: '14px'
                                    }}
                                  >
                                    {t('Add attachment')}
                                    <input
                                      type="file"
                                      name="file"
                                      id={`file_input_new_${take.id}`}
                                      ref="takeAddAttach"
                                      onChange={e =>
                                        this.handleFileChange(e, take.id)}
                                      style={{ display: 'none' }}
                                    />
                                  </label>
                                </div>
                              )}
                              {(enableDiv
                                || currentUser.id == take.added_by) && (
                                  <div
                                    className="wspopupmenu-list clickable takeawayMenuText wb-meeting-topic-add"
                                    onClick={() =>
                                      this.deleteTakeAway(
                                        take.id,
                                        meetingObj.id,
                                        this.state.type,
                                        topicId,
                                        meetingObj,
                                        take.files
                                      )}
                                  >
                                    {t('Delete')}
                                  </div>
                                )}

                              <div
                                className="wspopupmenu-list takeawayMenuText clickable wb-meeting-remindme"
                                data-type="take"
                                onClick={() =>
                                  this.remindMeTopicTakeClick(take.id)}
                                style={{ paddingLeft: '12px' }}
                              >
                                <input
                                  className={`clickable remindDate remindMe_${take.id}`}
                                  type="text"
                                  name="meeting_remind_me"
                                  id={`remindTopicTakeMe_${take.id}`}
                                  style={{
                                    height: '0px',
                                    width: '0px',
                                    border: '0px',
                                    padding: '0px'
                                  }}
                                />
                                {t('Remind Me')}
                              </div>
                              {take.added_by != currentUser.id && (
                                <div
                                  className="wspopupmenu-list takeawayMenuText clickable sendBadge"
                                  data-type="take"
                                  data-member-id={meetingObj.user_id}
                                >
                                  {t('Give Feedback')}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {!this.isAITakeaway(take) ? (
                          <div className="topicTakeDesc">
                            {this.topicTakeDesc(take, enableDiv, cursorP)}
                          </div>
                        ) : (
                          <div className="takeawayContentMetadata">
                            {this.aiTopicArea(take)}
                          </div>
                        )}
                        {take.tag != 1 ? (
                          <div className="takeawayDescriptionSubtext">
                            <div className="floatLeft">
                              <span className="relTopicNoteUserName truncateText dispIB floatLeft">
                                {`${take.firstname} ${take.lastname}`}
                              </span>
                              <span className="relTopicNoteDateTime floatLeft dispIB">
                                {take.create_period}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                  </div>
                  {this.displaySmartWoboInline(take.id, topicId, take)}
                </div>
                {typeof take.files !== 'undefined'
                  && take.files.length > 0 && (
                    <TakeAttachment
                      meeting={meetingObj}
                      isNoAttachmentDownload={
                        this.props.isNoAttachmentDownload
                      }
                      topicMiddle={topic}
                      take={take}
                      takeawaysFile={take.files}
                      currentUser={this.props.currentUser}
                      userPermission={this.props.userPermission}
                      deleteNoteAttach={this.props.deleteNoteAttach}
                      isFUSEnabled={this.props.isFUSEnabled}
                    />
                  )}
              </div>
              {take.id === this.props.takeSmartWoboId && this.displaySmartWoboUsersDropdown()}
            </div>
          ))
          : ''}
        {this.state.enableText ? (
          <PostTopicSubTakeawaysNotes
            currentUser={this.props.currentUser}
            saveTags={this.props.saveTags}
            updateTopicTake={updateTopicTake}
            topicId={topicId}
            meetingObj={meetingObj}
            userPermission={this.props.userPermission}
            saveMeetingTakeAway={this.props.saveMeetingTakeAway}
            closeTextArea={this.closeTextArea}
            fName={fName}
            mentionsUserData={this.props.mentionsUserData}
            mtS3Data={this.props.mtS3Data}
            actions={this.props.actions}
            elementHeight={this.state.elementH}
          />
        ) : (
          ''
        )}
        <div className="takeawayContainer add-another">
          <div className="takeawayBodyContent" onClick={e => this.openTextArea(e)}>
            <span style={{ fontStyle: 'normal' }}>+&nbsp;</span>{t('Add another')}
          </div>
        </div>
      </section>
    );
  }
}
export default withTranslation()(ListTakeawaysNotes);
